import { useEffect, useMemo } from 'react'
import { useLocation } from 'react-router-dom'

import { ACCOUNT_ID_REGEX } from 'constants/RegExs'

import { useEngagementService } from './useEngagementService'

function prepareURL(pathname: string) {
  return new URL(pathname.replace(ACCOUNT_ID_REGEX, '/accountId/'), window.location.origin).href
}

/**
 * Sends URL visit events to the engagement platform
 */
export const useEngagementServiceNavigationSubscription = () => {
  const engagementService = useEngagementService()
  const { pathname } = useLocation()
  const visitUrl = useMemo(() => prepareURL(pathname), [pathname])

  useEffect(() => {
    engagementService.logEvent('visit_url', {
      url: visitUrl,
    })
  }, [visitUrl, engagementService])
}
